import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import CommonApi from '../../../../apis/common'
import 'bootstrap-daterangepicker/daterangepicker.css';
import PillButtonSelect from '../../../common/pill-button-select/pill-button-select';

class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: true,
        disableGo: true,
        questionSource: 'countingwell',
        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: {},
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true,
        durationDropDown: [],
        singleChapterDropdown: [{ title: "15 Mins", value: 15 }],
        selectedChapter: [],
        duration: 15,
        maxChapterSelection: 4,
        sectionDropdownItems : []

    }

    classSectionHash = {}
    config = {}

    componentDidMount() {
        this.getClasses()
        this.getMisc()
    };


    getMisc() {
        let payload = {
            "type": "ASSESSMENT_META"
        }
        CommonApi.getMisc(payload)
            .then(response => {
                let misc = response[0]
                this.config = misc
                console.log(this.config)
                this.setState({ maxChaptersAllowed: misc.maxChaptersAllowed })
            }).catch(err => {
            })
    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: boards[0] })
                }
                this.setState({ classDropdownItems: classes, selectedClass: null, reloadClassPill: true }, () => {
                    this.setState({ reloadClassPill: false })
                })
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        if (!payload.board) payload.board = this.state.selectedBoard?.value

        if (this.classSectionHash[payload.board + payload.class]) {
            this.setState({ sectionDropdownItems: this.classSectionHash[payload.board + payload.class], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i].section,
                            sectionId: response.response[i]._id
                        })
                    }
                }

                console.log(sections)

                
                this.classSectionHash[payload.board + payload.class] = sections?.length ? sections : null
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        // if (!payload.board) payload.board = this.state.selectedBoard
        if (!payload.class) return
        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })
                }
                this.setState({ chapterDropDownItems: chapters, selectedChapter: "", reloadChapterDropdown: true }, () => {
                    this.setState({ reloadChapterDropdown: false })
                })
            }).catch(err => {
            })
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectPillButton = (option, key) => {
        console.log(option)
        let reloadChapterDropdown = false, selectedChapter = this.state.selectedChapter
        if (key === "selectedSection") {
            reloadChapterDropdown = true
            selectedChapter = null
        }
        this.setState({ [key]: option, reloadChapterDropdown, selectedChapter }, () => {
            if (key == "selectedBoard") {
                this.getClasses()
                this.setState({ sectionDropdownItems: [] })
                if(this.props.onBoardChange) this.props.onBoardChange()
                this.setState({
                    selectedClass: "",
                    selectedSection: "",
                    questionSource: "countingwell",
                    duration: 15,
                    selectedChapter: []
                })
            }
            if (key === "selectedClass") {
                this.getSections({ class: option?.value })
                this.getChapters()
                this.setState({ durationDropDown: [], duration: "" })
            }

            if (key === "selectedSection") {
                this.setState({ reloadChapterDropdown: false }, () => {
                    this.onMultiSelectDropdown([], "selectedChapter")
                })
            } else {
                this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            }
        })
    }
    onMultiSelectDropdown = (options, key) => {
        let value = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option)

            if (key == "selectedChapter") {
                let chapterInfo = this.config.chapters
                let configs = chapterInfo[value.length]
                if (configs) {
                    let dropdownList = []
                    configs.forEach(element => {
                        let obj = {
                            title: `${element.duration?.value} ${element.duration?.unit}`,
                            value: element.duration?.value
                        }
                        dropdownList.push(obj)
                    });
                    this.setState({ durationDropDown: dropdownList, reloadDurationDropdown: true }, () => {
                        this.setState({ reloadDurationDropdown: false })
                    })
                } else {
                    this.setState({ durationDropDown: [], duration: "", reloadDurationDropdown: true }, () => {
                        this.setState({ reloadDurationDropdown: false })
                    })
                }
            }
        }
        this.setState({ reloadDropdown: true, [key]: value, duration: "" }, () => {
            this.setState({ reloadDropdown: false })
            this.emitChanges(key == "selectedChapter")
        })
    }

    handleDateEvent = (event, picker) => {
        this.startDate = new Date(picker.startDate);
        this.setState({ selectedDate: this.startDate.toLocaleDateString() });
        this.emitChanges()
    }


    emitChanges(reloadQuestion, reloadStudent) {

        let chapters = []

        if (this.state.selectedChapter && this.state.selectedChapter?.length) {
            chapters = this.state.selectedChapter?.map(item => {
                return {
                    key: item.value,
                    title: item.title
                }
            })
        }

        let payload = {
            board: this.state.selectedBoard?.value,
            class: this.state.selectedClass?.value,
            section: this.state.selectedSection?.title,
            sectionId: this.state.selectedSection?.sectionId,
            chapters: chapters,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()) : "",
            masterDataId: this.state.masterDataId,
            duration: chapters.length === 1 ? 15 : this.state.duration,
            questionSource: this.state.questionSource
        }

        console.log(payload)

        if (this.props.onGo) {
            this.props.onGo(payload, reloadQuestion, reloadStudent)
        }
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value }, () => {
            this.emitChanges(key == "duration")
        })
    }

    onSelectChapter = (option) => {
        if (option) option = [option]
        this.setState({ "selectedChapter": option }, () => {
            this.emitChanges(true)
            if(this.props.resetSelectedQuestions) this.props.resetSelectedQuestions()
        })
    }

    getChapterSelectedOrNot(value) {
        let chapters = this.state.selectedChapter || []
        for (let i = 0; i < chapters.length; i++) {
            if (chapters[i].value === value) return true
        }

        return false
    }

    setQuestionSource = val => {
        this.setState({ questionSource: val }, _ => {
            this.emitChanges(true)
        })
    }

    render() {
        const {questionSource} = this.state
        return (

            <div className="new-test-filter">
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-12 pt-4">
                                            <div className="filter-input-label">
                                                Board
                                            </div>
                                            <div className="px-2">
                                                <PillButtonSelect
                                                    onSelect={(value, option) => this.onSelectPillButton(option, "selectedBoard")}
                                                    options={this.state.boardsDropdownItems}
                                                    value={this.state.selectedBoard}
                                                    width="150px"
                                                    invalid={this.state.isSubmit && !this.state.selectedBoard}
                                                />
                                            </div>
                                        </div>
                                        : ""
                                }

                                {
                                    !this.state.reloadClassPill ?
                                        <div className="col-12  pt-4">
                                            <div className="filter-input-label">
                                                Class
                                            </div>
                                            <div className="px-2">
                                                <PillButtonSelect
                                                    onSelect={(value, option) => this.onSelectPillButton(option, "selectedClass")}
                                                    options={this.state.classDropdownItems}
                                                    value={this.state.selectedClass?.value}
                                                    width="150px"
                                                    invalid={this.state.isSubmit && !this.state.selectedClass}
                                                />

                                            </div>
                                        </div> : ""
                                }
                                {
                                    this.state.selectedClass && this.state.sectionDropdownItems?.length ?
                                        <div className="col-12  pt-4">
                                            <div className="filter-input-label">
                                                Sections <span className="optional"> OPTIONAL </span>
                                            </div>
                                            <div className="px-2">
                                                {
                                                    !this.state.reloadDropdown ?
                                                        <PillButtonSelect
                                                            onSelect={(value, option) => this.onSelectPillButton(option, "selectedSection")}
                                                            options={this.state.sectionDropdownItems}
                                                            value={this.state.selectedSection?.value}
                                                            width="100px"
                                                            invalid={this.state.isSubmit && !this.state.selectedSection}
                                                        />
                                                        : ""
                                                }
                                            </div>
                                        </div>
                                        : ""
                                }
                            </div>
                            {this.state.selectedClass ?
                                <div className="pt-4">
                                    <div className="filter-input-label">
                                        Chapter
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadChapterDropdown ?
                                                this.state.selectedSection && this.props.type != "DIAGNOSTIC" ?
                                                    <DropdownV4
                                                        key="chapter-multi-select"
                                                        placeholder='Select Chapter'
                                                        options={this.state.chapterDropDownItems}
                                                        onSelect={(option) => this.onMultiSelectDropdown(option, "selectedChapter")}
                                                        text={"title"}
                                                        multiSelect
                                                        max={this.state.maxChaptersAllowed || 4}
                                                        value={this.state.selectedChapter}
                                                    />
                                                    : <DropdownV4
                                                        key="chapter-single-select"
                                                        placeholder='Select Chapter'
                                                        options={this.state.chapterDropDownItems}
                                                        onSelect={(option) => this.onSelectChapter(option)}
                                                        text={"title"}
                                                        showRadio
                                                    />
                                                : ""
                                        }
                                    </div>
                                    {this.state.selectedSection && this.props.type != "DIAGNOSTIC" ? <div className="note pt-2 pl-2">NOTE: Max 4 chapters could be selected for assessment at section level</div> : ""}
                                </div>
                                : ""
                            }

                            <div className="row">
                                {
                                    this.state.selectedClass ?
                                        <div className="col-lg-6 col-md-6 col-sm-12  pt-4">
                                            <div className="filter-input-label">
                                                Due Date
                                            </div>
                                            <div>
                                                <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                                    autoApply={true}
                                                    initialSettings={{ singleDatePicker: true, minDate: new Date(), startDate: this.startDate, autoUpdateInput: false }}
                                                    locale={{
                                                        'format': 'DD/MM/YYYY'
                                                    }}
                                                ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedDate}></input>
                                                    {/* <img className='cursor-pointer' src={getImageSource(ImageConstants.CALENDAR)} /> */}
                                                </DateRangePicker>

                                            </div>
                                        </div> : ""
                                }
                                {
                                    this.state.selectedClass ?
                                        <div className="col-lg-6 col-md-6 col-sm-12  pt-4">
                                            <div className="filter-input-label">
                                                Duration
                                            </div>
                                            <div>
                                                {
                                                    this.state.selectedChapter?.length > 1 ?
                                                        <Dropdown
                                                            placeholder='Select Duration'
                                                            options={this.state.durationDropDown}
                                                            onSelect={(option) => this.onSelectDropDown(option, "duration")}
                                                            text={"title"}
                                                            value={this.state.duration}
                                                        />
                                                        :
                                                        <input
                                                            key="disabled-dropdown"
                                                            className="cw-input not-editable"
                                                            style={{ background: "white" }}
                                                            placeholder={this.state.selectedChapter?.length == 1 ? "15 Mins" : "Duration"}
                                                            value={this.state.duration}
                                                            disabled
                                                        />
                                                }
                                            </div>
                                        </div> : ""
                                }
                            </div>
                            {
                                this.state.selectedClass && (
                                    <div className='row'>
                                    <div className='col mt-5'>
                                        <div className="filter-input-label">
                                            Questions Source
                                        </div>
                                        <div className='my-1 question-source-card'>
                                            <div className='question-source-choice'>
                                                <div className='radio-container'>
                                                    <div
                                                        className={`custom-radio cursor-pointer ${questionSource === 'countingwell' &&
                                                        'active'}`}
                                                        onClick={_ => this.setQuestionSource('countingwell')}
                                                    >
                                                        <div className='radio-button'>
                                                        {questionSource === 'countingwell' && <div></div>}
                                                        </div>
                                                        <div className='radio-label'>Let Countingwell add Questions</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='question-source-choice'>
                                                <div className='radio-container'>
                                                    <div
                                                    className={`custom-radio cursor-pointer ${questionSource === 'questionbank' &&
                                                        'active'}`}
                                                    onClick={_ => this.setQuestionSource('questionbank')}
                                                    >
                                                    <div className='radio-button'>{questionSource === 'questionbank' && <div></div>}</div>
                                                    <div className='radio-label'>Pick from My Question bank</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                )
                                }
                        </div> : ""

                }
            </div>


        );
    }

}

export default FilterComponent;